import { take, all } from 'redux-saga/effects'

/**
 * Wait for an event to happen (action to be dispatched),
 * but also handle if the event already happened in the past.
 * @param waitList Array of arrays, while each inner array has the following structure:
 * [hasEventAlreadyHappened, ...list of actions, one of them will unblock the event]
 * usually hasEventAlreadyHappened will be a result of a state selector (data is already fetched),
 * list of actions will be two actions, a success and a failure of a fetching event
 * @returns {IterableIterator<*>}
 */
function* waitFor(waitList) {
  const actionsToWait = []

  waitList.forEach((waitItem) => {
    const [readyState, ...oneOfActions] = waitItem

    if (!readyState) {
      actionsToWait.push(take(oneOfActions))
    }
  })

  if (actionsToWait.length > 1) {
    yield all(actionsToWait)
  } else {
    yield actionsToWait[0]
  }
}

const yieldSagasGenerator = (sagas) => {
  return function* yieldSagas() {
    yield sagas
  }
}

export { waitFor, yieldSagasGenerator }
